import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LangProvider } from '@dia/i18n';
import { ErrorBoundary } from '@dia/ui';
import { shellCssVariables } from '@dia/ui/tokens';
import { App } from './App';
import { storedDefaultLang } from './screens/lib/roleLang';
import { AuthProvider } from './auth';
import { registerServiceWorker } from './serviceWorker';
import { sync } from './supabase';
import './index.css';

/**
 * Sunlight mode, Spanish by default (Section 9 and Section 10). The crew can
 * leave the toggle where it is; the hosts and the owners can flip it.
 */
const style = document.createElement('style');
style.textContent = shellCssVariables('ops');
document.head.prepend(style);

sync.start();

// A new deploy reaches a phone that already has the app (see serviceWorker.ts).
if (import.meta.env.PROD) registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Outside every provider on purpose: if one of them is what crashed, this
        still draws. Each route has its own boundary too, in App.tsx. */}
    <ErrorBoundary>
      <LangProvider defaultLang={storedDefaultLang()} storageKey="dia.ops.lang">
        <AuthProvider>
          <App />
        </AuthProvider>
      </LangProvider>
    </ErrorBoundary>
  </StrictMode>,
);
